import React from 'react';
import { FiLock, FiLink } from 'react-icons/fi';

// Task order rule of an automation checklist.
// mandatory = tasks with the lock icon must be checked in order (no task after a locked one can be checked before it);
// tasks with the chain icon are optional and never block. optional = any order (automations saved before this option).
// Saved per item as inOrder: true (lock); the rule's mode is "mandatory" when any item has it.
export const ORDER_MANDATORY = 'mandatory';
export const ORDER_OPTIONAL = 'optional';

export const orderModeOf = (items) =>
    Array.isArray(items) && items.some((i) => i?.inOrder) ? ORDER_MANDATORY : ORDER_OPTIONAL;

// Saved items -> form items: in mandatory mode an item without inOrder is optional (chain icon)
export const orderFlagsFromSaved = (item, mode) => (mode === ORDER_MANDATORY && !item?.inOrder ? { optional: true } : {});

export const orderPayload = (item, mode) => (mode === ORDER_MANDATORY && !item?.optional ? { inOrder: true } : {});

export const OrderRuleRadio = ({ value, onChange, name }) => (
    <div className="flex flex-wrap items-center gap-3 text-sm text-gray-700 mb-2">
        <span className="font-medium">Task Order Rule:</span>
        <label className="flex items-center gap-1" style={{ cursor: 'pointer' }}>
            <input
                type="radio"
                name={name}
                checked={value === ORDER_MANDATORY}
                onChange={() => onChange(ORDER_MANDATORY)}
                style={{ accentColor: '#1a7d3e' }}
            />
            Mandatory (Enforce sequence)
        </label>
        <label className="flex items-center gap-1" style={{ cursor: 'pointer' }}>
            <input
                type="radio"
                name={name}
                checked={value === ORDER_OPTIONAL}
                onChange={() => onChange(ORDER_OPTIONAL)}
                style={{ accentColor: '#1a7d3e' }}
            />
            Optional (Any order)
        </label>
        {value === ORDER_MANDATORY && (
            <span className="text-xs text-gray-500 w-full" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 4 }}>
                <FiLock size={11} style={{ display: 'inline-block' }} /> locked tasks must be checked in order — nothing after
                them can be checked first. Click the icon to switch a task to
                <FiLink size={11} style={{ display: 'inline-block' }} /> optional (can be checked any time).
            </span>
        )}
    </div>
);

// Number badge + lock / chain icon in front of a checklist task in the automation form
export const OrderBadge = ({ index, mode, optional, onToggle }) => {
    const locked = mode === ORDER_MANDATORY && !optional;
    const Icon = locked ? FiLock : FiLink;
    return (
        <span className="flex items-center gap-1" style={{ flexShrink: 0 }}>
            <span
                style={{
                    minWidth: 26,
                    height: 22,
                    borderRadius: 11,
                    background: '#e8f5ec',
                    color: '#1a7d3e',
                    fontSize: 11,
                    fontWeight: 700,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {String(index + 1).padStart(2, '0')}
            </span>
            <button
                type="button"
                disabled={mode !== ORDER_MANDATORY}
                onClick={onToggle}
                title={
                    mode !== ORDER_MANDATORY
                        ? 'Any order (choose "Mandatory" above to lock tasks)'
                        : locked
                          ? 'Mandatory in order — click to make it optional'
                          : 'Optional — click to make it mandatory in order'
                }
                style={{
                    border: 'none',
                    background: 'transparent',
                    padding: 2,
                    display: 'flex',
                    cursor: mode === ORDER_MANDATORY ? 'pointer' : 'default',
                    color: locked ? '#374151' : '#9ca3af',
                }}
            >
                <Icon size={14} />
            </button>
        </span>
    );
};
